import { call, put, takeEvery } from "redux-saga/effects";
import resources from "../../../config/resources";
import config from "../../../config/index";
import fetchService from "../../../lib/fetchService";
import {
  CONFIRM_JOB_ORDER_CONFIRMATION_REQUEST,
  confirmOrderConfirmationSuccess,
  confirmOrderConfirmationError,
} from "./action";
import { handleSagaError } from "../../../dataproviders/errorResponseHandler";

const requestSaga = function*({ payload }) {
  const { job } = payload;

  const url = `${config.urls.BACKEND}/v2/${resources.JOBS}/${encodeURIComponent(job)}/confirmOC`;

  try {
    const response = yield call(fetchService.post, url);

    for (const action of yield call(handleSagaError, response, confirmOrderConfirmationError)) {
      yield put(action);
      return;
    }

    if (response.ok) {
      const responseData = yield call(() => response.json());
      yield put(confirmOrderConfirmationSuccess(responseData));
    } else {
      const statusCode = response.status;
      yield put(confirmOrderConfirmationError(new Error(`Request failed with error ${statusCode}!`)));
    }
  } catch (e) {
    yield put(confirmOrderConfirmationError(e));
  }
};

export default function*() {
  yield takeEvery(CONFIRM_JOB_ORDER_CONFIRMATION_REQUEST, requestSaga);
}
